export const getExponentialParts = (num: number | string) => {
  return String(num).split(/[eE]/)
}

export const fromExponent = (num: number | string) => {
  const [value, ePart] = getExponentialParts(num)
  if (!ePart) {
    return value
  }

  const e = Number(ePart)

  if (e === 0) {
    return value
  }

  const sign = value[0] === '-' ? '-' : ''
  const digits = value.replace(/^-/, '')
  const [wholeDigits, fractionDigits = ''] = digits.split('.')

  if (e < 0) {
    // move dot to the left
    const countWholeAfterTransform = wholeDigits.length + e
    if (countWholeAfterTransform > 0) {
      // transform whole to fraction
      const wholeAfterTransform = wholeDigits.slice(0, countWholeAfterTransform)
      const wholeTransformedToFraction = wholeDigits.slice(countWholeAfterTransform)
      return `${sign}${wholeAfterTransform}.${wholeTransformedToFraction}${fractionDigits}`
    }

    // not enough whole digits: prepend with fractional zeros
    // first e goes to dotted zero
    const zerosCount = -countWholeAfterTransform
    const zeros = '0.' + '0'.repeat(zerosCount)
    return `${sign}${zeros}${wholeDigits}${fractionDigits}`
  }

  // move dot to the right
  const countFractionAfterTransform = fractionDigits.length - e
  if (countFractionAfterTransform > 0) {
    // transform fraction to whole
    const fractionAfterTransform = fractionDigits.slice(e)
    const fractionTransformedToWhole = fractionDigits.slice(0, e)
    return `${sign}${wholeDigits}${fractionTransformedToWhole}.${fractionAfterTransform}`
  }

  // not enough fractions: append whole zeros
  const zerosCount = -countFractionAfterTransform
  const zeros = '0'.repeat(zerosCount)
  return `${sign}${wholeDigits}${fractionDigits}${zeros}`
}
